import { render, staticRenderFns } from "./NewPageContext.vue?vue&type=template&id=296edc69&scoped=true"
import script from "./NewPageContext.vue?vue&type=script&lang=js"
export * from "./NewPageContext.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296edc69",
  null
  
)

export default component.exports